import {environment} from '../../../environments/environment';

export interface MainNavigationItem {
  key: 'feed' | 'events' | 'places' | 'vehicles' | 'ranking' | 'marketplace';
  icon: string;
  labelKey: string;
  routerLink: string[];
  showInTopbar: boolean;
  showInFooter: boolean;
  footerIconKind: 'prime' | 'vehicles-combo';
  footerOrder?: number;
  footerTutorialKey?: string;
  enabled: boolean;
}

export const MAIN_NAVIGATION_ITEMS: MainNavigationItem[] = [
  {
    key: 'feed',
    icon: 'pi pi-hashtag fs-large',
    labelKey: 'shared.top_bar.menu.feed',
    routerLink: ['/feed'],
    showInTopbar: true,
    showInFooter: false,
    footerIconKind: 'prime',
    footerOrder: 10,
    footerTutorialKey: 'tutorial-footer-feed',
    enabled: true,
  },
  {
    key: 'events',
    icon: 'pi pi-calendar fs-large',
    labelKey: 'shared.top_bar.menu.events',
    routerLink: ['/events'],
    showInTopbar: true,
    showInFooter: true,
    footerIconKind: 'prime',
    footerOrder: 20,
    footerTutorialKey: 'tutorial-footer-events',
    enabled: true,
  },
  {
    key: 'places',
    icon: 'pi pi-map-marker fs-large',
    labelKey: 'shared.top_bar.menu.places',
    routerLink: ['/places'],
    showInTopbar: true,
    showInFooter: false,
    footerIconKind: 'prime',
    enabled: true,
  },
  {
    key: 'vehicles',
    icon: 'pi pi-car fs-large',
    labelKey: 'shared.top_bar.menu.vehicles',
    routerLink: ['/vehicles'],
    showInTopbar: true,
    showInFooter: true,
    footerIconKind: 'vehicles-combo',
    footerOrder: 10,
    footerTutorialKey: 'tutorial-footer-vehicles',
    enabled: environment.vehiclesCatalogNavigationEnabled,
  },
  {
    key: 'ranking',
    icon: 'pi pi-trophy fs-large',
    labelKey: 'shared.top_bar.menu.ranking',
    routerLink: ['/ranking'],
    showInTopbar: true,
    showInFooter: true,
    footerIconKind: 'prime',
    footerOrder: 30,
    footerTutorialKey: 'tutorial-footer-ranking',
    enabled: true,
  },
  {
    key: 'marketplace',
    icon: 'pi pi-dollar fs-large',
    labelKey: 'shared.top_bar.menu.marketplace',
    routerLink: ['/marketplace'],
    showInTopbar: true,
    showInFooter: true,
    footerIconKind: 'prime',
    footerOrder: 40,
    footerTutorialKey: 'tutorial-footer-marketplace',
    enabled: true,
  },
];

export function getMainNavigationItems(): MainNavigationItem[] {
  return MAIN_NAVIGATION_ITEMS.filter((item) => item.enabled);
}

export function isMainNavigationItemActive(url: string, item: MainNavigationItem): boolean {
  const normalizedUrl = (url || '').split('?')[0];

  if (item.key === 'vehicles') {
    return normalizedUrl === '/vehicles' || normalizedUrl.startsWith('/vehicles/');
  }

  return normalizedUrl === item.routerLink[0] || normalizedUrl.startsWith(`${item.routerLink[0]}/`);
}
